import { ApiFile } from "@/types/common.types.ts";
import { ApiEmployeeShort } from "@/types/employees/employee.types.ts";
import { ApiEvent, ApiEventSavePayload } from "@/types/event.types.ts";
import {
  ApiEmail,
  ApiEmailBaseSendPayload,
  ApiEmailSendPayload,
} from "@/types/integrations/integration.types.ts";
import { ApiApplicantCVSource } from "@/types/recruit/applicant.cv.types.ts";
import {
  ApiApplicantCommentData,
  ApiApplicantFilter,
  ApiApplicantShort,
} from "@/types/recruit/applicant.types.ts";
import { ApiCandidateDisqualificationReason } from "@/types/recruit/disqualification-reason.types.ts";
import { ApiOfferRequest } from "@/types/recruit/offer.types.ts";
import { ApiCandidateFeedback } from "@/types/recruit/scorecard.types.ts";

export enum ApiActionVisibilities {
  myself = "myself",
  public = "public",
  recruiters = "recruiters",
  stakeholders = "stakeholders",
}

export enum ApiActionTypes {
  created = "created", // FE only
  stage_changed = "stage_changed",
  comment_added = "comment_added",
  disqualified = "disqualified",
  merged = "merged",
  assigned = "assigned",
  qualified = "qualified",
  email_sent = "email_sent",
  event = "event",
  offer_created = "offer_created",
  feedback = "feedback",
  cv_added = "cv_added",
}

export enum ApiActionLogEntityTypes {
  stage = "stage",
  comment = "comment",
  file = "file",
  email = "email",
}

export interface ApiActionPipelineStage {
  id: number;
  title: string;
}

export enum ApiActionItemTypes {
  applicant = "applicant",
  candidate = "candidate",
}

export interface ApiAction {
  id: number;
  type: ApiActionTypes;
  item_id: number;
  item_type: ApiActionItemTypes;
  log_entity_type?: ApiActionLogEntityTypes;
  datetime_action_date: Date;
  author: ApiEmployeeShort | null;
  visibility: ApiActionVisibilities;
  files: ApiFile[];

  comment?: string;
  pipeline_stage?: ApiActionPipelineStage;
  disqualification_reason?: ApiCandidateDisqualificationReason;
  reserved?: boolean;
  message?: ApiEmail;
  event?: ApiEvent;
  feedback?: ApiCandidateFeedback;
  merged_applicant?: ApiApplicantShort;
  comment_data?: ApiApplicantCommentData;
  offer_request?: ApiOfferRequest;
  source?: ApiApplicantCVSource;
}

export interface ApiActionPayload {
  pipeline_stage_id?: number;
  disqualification_reason_id?: number;
  reserved?: boolean;
  comment?: string;
  file_uuids?: string[];
  datetime_action_date?: Date;

  email?: ApiEmailSendPayload | ApiEmailBaseSendPayload;
  event?: ApiEventSavePayload;
  visibility: ApiActionVisibilities;
  offer_id?: number;
}

export interface ApiActionCreateByFilterPayload {
  filter: ApiApplicantFilter;
  action: ApiActionPayload;
}
